import React, { useCallback } from 'react';
import fr from 'facet-rest';
import useUserContext from 'Context/UserContext';
import { Route, Switch } from 'Components/UI/FacetRouter/FacetRouter';
import { clientPage } from 'Consts/Strings';
import Page from 'Views/Page';
import useMobileLayout from 'Hooks/useMobileLayout';
import { useLayoutContext } from 'Context/LayoutContext';
import { AnnouncementBanner } from 'Context/AnnouncementContext/Banner';
import Viewport from './Viewport';
import { BottomNavDrawer } from './Navigation/BottomNav/Drawer';
import { ProfileImageProvider } from '../ProfileImageContext';
import TopNav from './Navigation/TopNav';
import { BottomNav } from './Navigation/BottomNav';
import { ClientNavPicker } from './Navigation/TopNav/ClientNavPicker';

const PageWithAnnouncements = () => <Page showAnnouncements />;

const CombinedAppContent = () => {
  const { userResource } = useUserContext();
  const isMobile = useMobileLayout();
  const { hideBottomNavigation, isNavigationVisible } = useLayoutContext();
  const { showMobileMenuFrom, setShowMobileMenuFrom } = useLayoutContext();
  const closeMenuIfOpen = useCallback(() => setShowMobileMenuFrom(null), []);

  return (
    <ProfileImageProvider
      profileImageLink={userResource?.relationship(fr.relationships.profileImage.name)?.link('related')}
    >
      <AnnouncementBanner />
      {!isMobile && isNavigationVisible && <TopNav Component={ClientNavPicker} />}
      <Switch>
        <Route path={clientPage} component={PageWithAnnouncements} />
        <Viewport />
      </Switch>
      <BottomNavDrawer open={!!showMobileMenuFrom} from={showMobileMenuFrom} onClose={closeMenuIfOpen} />
      {isMobile && !hideBottomNavigation && isNavigationVisible && <BottomNav />}
    </ProfileImageProvider>
  );
};

export default CombinedAppContent;
